import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Modal, Spin } from "antd";
import { useSnackbar } from "notistack";
import { deleteOrg, deleteQboOrg } from "../../utils/organization";

const DeleteOrgModal = ({
  deleteTargets,
  organizationName,
  modalStatus,
  setModalStatus,
  onModalClose,
  onSuccess,
}) => {
  const { getIdTokenClaims } = useAuth0();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const handleDeleteOrg = () => {
    if (!deleteTargets?.length) return;

    setLoading(true);

    setTimeout(async () => {
      try {
        const token = await getIdTokenClaims();

        for (const t of deleteTargets) {
          const deleteApi = t.provider === "qbo" ? deleteQboOrg : deleteOrg;
          const response = await deleteApi(token.__raw, t.id);
          if (response.data?.message) {
            enqueueSnackbar(response.data.message, {
              variant: "success",
            });
          }
        }

        onSuccess();
      } catch (err) {
        console.error("Error deleting organization:", err);
        enqueueSnackbar("An error occurred while deleting the organization.", {
          variant: "error",
        });
      } finally {
        setLoading(false);
        setModalStatus(false);
        onModalClose();
      }
    }, 2000);
  };

  const count = deleteTargets?.length ?? 0;

  return (
    <Modal
      title={<div className="text-2xl">Delete Organization</div>}
      centered
      open={modalStatus}
      footer={[
        <div className="flex justify-end gap-3" key="footer">
          <div
            className="px-2 text-sm py-1.5 border border-gray-200 rounded-lg cursor-pointer"
            onClick={() => {
              setModalStatus(false);
              onModalClose();
            }}
          >
            Cancel
          </div>

          <div
            className={`px-2 text-sm py-1.5 bg-blue-500 text-white rounded-lg cursor-pointer flex items-center gap-2 ${
              loading ? "opacity-75 cursor-not-allowed" : ""
            }`}
            onClick={!loading ? handleDeleteOrg : null}
          >
            {loading && (
              <Spin
                size="small"
                style={{ filter: "brightness(0) invert(1)" }}
              />
            )}
            Confirm
          </div>
        </div>,
      ]}
      onCancel={() => {
        setModalStatus(false);
        onModalClose();
      }}
    >
      <div className="py-8 text-gray-500 text-sm border-b border-gray-300">
        <div>
          Are you sure you want to delete
          <b className="ml-2">
            {count > 1
              ? `${count} organizations`
              : `${organizationName ?? "this organization"}`}
            ?
          </b>
        </div>
        <div className="mt-6">
          This action will unsubscribe these organizations, delete all backup
          and archive data. Please note it cannot be undone.
        </div>
      </div>
    </Modal>
  );
};

export default DeleteOrgModal;
